import React, {useState, createContext, useCallback, useEffect} from "react";
import {Spin} from "antd";
import {ArrowRightOutlined} from "@ant-design/icons";
import {set} from "lodash";
import {useRequest} from "../utils/hooks";
import {ORDER_INFO_PROJECTION} from "./consts.jsx";
import {StringBuilder} from "../AppUtils.js";
import {mapRatingImagesToFrontend} from "./utils.jsx";
import "./order-feedback.css";

export const OrderFeedbackContext = createContext(null);

export const OrderFeedbackProvider = ({children, match, history, showBackButton = false}) => {
    const {orderId} = match.params;
    const [order, loadingOrder] = useRequest(
        `/api/events/${orderId}/orderInfo`,
        "POST",
        ORDER_INFO_PROJECTION,
        [orderId],
        !!orderId
    );

    const [formValues, setFormValues] = useState({
        rating: 0,
        selectedOptions: [],
        comment: "",
        images: []
    });

    useEffect(() => {
        if (order?.rating) {
            const images = mapRatingImagesToFrontend(order.rating.images);

            setFormValues(prev => ({
                ...prev,
                rating: order.rating.rating || 0,
                selectedOptions: order.rating.ratingAspects,
                comment: order.rating.comment || "",
                images
            }));
        }
    }, [order]);

    const onFormValueChange = useCallback((path, value) => {
        setFormValues(prev => {
            const newValues = {...prev};
            set(newValues, path, value);
            return newValues;
        });
    }, []);

    if (loadingOrder) {
        return (
            <div className="order-feedback-page">
                <div
                    className="order-feedback-container"
                    style={{display: "flex", justifyContent: "center", alignItems: "center", minHeight: "400px"}}>
                    <Spin size="large" />
                </div>
            </div>
        );
    }

    const title = new StringBuilder(order?.orderName || order?.productName || "", " | ")
        .append(order?.providerBrand)
        .toString();
    const orderNumber = order?.proposalId || orderId || "";

    return (
        <OrderFeedbackContext.Provider
            value={{
                order,
                orderId,
                loadingOrder,
                formValues,
                onFormValueChange
            }}>
            <div className="order-feedback-page">
                <div className="order-feedback-container">
                    <div className="order-feedback-header">
                        {history && showBackButton && (
                            <button
                                type="button"
                                className="order-feedback-back-button"
                                onClick={() => history.goBack()}
                                aria-label="חזור">
                                <ArrowRightOutlined />
                            </button>
                        )}
                        <div className="order-feedback-header-content">
                            <h1 className="order-feedback-title">{title}</h1>
                            <p className="order-feedback-order-number">
                                {new StringBuilder("הזמנה מס'").append(orderNumber).toString()}
                            </p>
                        </div>
                    </div>
                    {children}
                </div>
            </div>
        </OrderFeedbackContext.Provider>
    );
};
